import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import BikeNode from "./BikeNode";

const styles = {
  root: {
    width: "100vw",
    display: "flex",
    flexWrap: "nowrap",
    overflowX: "auto"
  },
  actualDistance: {
    margin: "17px 5px 0 5px"
  }
};

class BikeNodes extends Component {
  constructor(props) {
    super(props);
    // this.actualDistanceRef = React.createRef();
  }

  componentDidMount() {
    const { activeNodeIndex } = this.props;
    if (activeNodeIndex) {
      this.setState({ activeNodeIndex });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.nodeRef) {
      const { activeNodeIndex } = this.props;
      const distance = activeNodeIndex * 69; //+ this.actualDistanceRef.current.offsetWidth;
      this.nodeRef.scrollLeft = distance;
    }
  }

  render() {
    const {
      classes,
      route,
      // onNextNode,
      activeNodeIndex,
      navigationStarted,
      actualDistance
    } = this.props;
    const nodes = route.map((node, index) => {
      const active = index < activeNodeIndex;
      const current = index === activeNodeIndex;
      return (
        <BikeNode
          key={node.pid}
          number={node.number}
          active={active}
          current={current}
          content={node.content}
          // callback={onNextNode}
          navigationStarted={navigationStarted}
        />
      );
    });
    return (
      <div
        ref={r => {
          this.nodeRef = r;
        }}
        className={classes.root}
      >
        {/* {actualDistance ? (
          <span ref={this.actualDistanceRef} className={classes.actualDistance}>
            Afstand<br />
            {actualDistance}km
          </span>
        ) : null} */}
        {nodes}
      </div>
    );
  }
}

BikeNodes.propTypes = {
  classes: PropTypes.object.isRequired,
  route: PropTypes.array.isRequired,
  // onNextNode: PropTypes.func.isRequired,
  activeNodeIndex: PropTypes.number,
  navigationStarted: PropTypes.bool,
  actualDistance: PropTypes.number
};

export default withStyles(styles)(BikeNodes);



// WEBPACK FOOTER //
// ./src/NewRoute/atoms/BikeNodes.js